<template>
  <thead class="v-data-table-header">
    <!-- zero-height row: with table-layout fixed the first row's cells set the column widths -->
    <tr class="bm-col-row">
      <th
        v-for="h in headers"
        :key="'w' + h.value"
        :style="h.width ? 'width:' + h.width + 'px;min-width:' + h.width + 'px' : ''"
      ></th>
    </tr>
    <tr class="bm-group-row">
      <th
        v-for="(g, i) in groups"
        :key="'g' + i"
        :colspan="g.span"
        :class="{ 'bm-group-l': i > 0 }"
        class="text-start"
      >
        {{ g.text }}
      </th>
    </tr>
    <tr>
      <th
        v-for="h in headers"
        :key="h.value"
        :class="[h.align === 'end' ? 'text-end' : 'text-start', h.class]"
        :style="h.width ? 'width:' + h.width + 'px' : ''"
      >
        {{ h.text }}
      </th>
    </tr>
  </thead>
</template>

<script>
/** Two-row header for a v-data-table: the group row (PO · Budget · Pemakaian · Kesehatan) over the columns. */
export default {
  name: "budget-grouped-header",
  props: {
    /** [{ text, span }] — spans add up to headers.length */
    groups: { type: Array, required: true },
    /** the table's headers (text, value, align, width, class) */
    headers: { type: Array, required: true },
  },
};
</script>
